<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :show-close="false"
      width="546px"
      @closed="close"
      class="Company"
    >
      <template slot="title">
        <div>
          <div class="title">创建企业</div>
          <div class="title-text">
            补充企业信息，完成创建，以管理员的身份开启高效协作
          </div>
        </div>
        <i class="el-icon-close" style="cursor: pointer" @click="close"></i>
      </template>
      <div class="info">
        <el-form
          class="CreateCompany"
          ref="form"
          :rules="FORM_RULES"
          :model="formData"
          :colon="false"
          label-position="left"
          label-width="80px"
          :requiredMark="false"
          :hide-required-asterisk="true"
        >
          <el-form-item label="身份">
            <div class="identity-list">
              <div
                v-for="(item, index) in identityList"
                :key="index"
                :style="{ margin: index == 1 ? '0px 8px' : '' }"
                @click="handleIdentity(item.value)"
                :class="
                  item.value == formData.userType
                    ? 'identity-item-avtive identity-item '
                    : 'identity-item'
                "
              >
                {{ item.label }}
                <div
                  class="i-item-icon"
                  v-show="item.value == formData.userType"
                >
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="公司名称" prop="compName">
            <el-input
              v-model="formData.compName"
              placeholder="请输入"
              size="large"
              maxlength="200"
            ></el-input>
          </el-form-item>

          <div style="display: flex">
            <el-form-item
              label="所在地区"
              prop="stateId"
              style="width: 216.6px; margin-right: 8px"
            >
              <el-select
                v-model="formData.stateId"
                placeholder="请选择"
                clearable
                filterable
                size="large"
                :disabled="formData.userType === 3"
                @change="changeCountry"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.codeValue"
                  :label="item.cn"
                  :value="item.codeValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label-width="0"
              prop="provinceId"
              style="width: 136.6px; margin-right: 8px"
            >
              <el-select
                placeholder="请选择"
                size="large"
                v-model="formData.provinceId"
                filterable
                clearable
                @change="changeRegion"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.codeValue"
                  :label="item.cn"
                  :value="item.codeValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="!cityIsNeedWrite"
              label-width="0"
              prop="cityId"
              style="width: 136.6px"
            >
              <el-select
                v-model="formData.cityId"
                placeholder="请选择"
                clearable
                size="large"
                filterable
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.codeValue"
                  :label="item.cn"
                  :value="item.codeValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="联系人" prop="contactName">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入"
              size="large"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="formData.userType == 1"
            label="工艺"
            prop="compAbilities"
          >
            <el-select
              v-model="formData.compAbilities"
              placeholder="请选择"
              multiple
              :multiple-limit="5"
              el-select
              style="width: 100%"
              size="large"
              @change="handleCompAbilities"
            >
              <el-option-group
                v-for="(list, index) in compAbilitiesOptions"
                :key="index"
                :label="list.group"
              >
                <el-option
                  v-for="item in list.children"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >
                  {{ item.label }}
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="formData.userType == 3"
            label="服务类型"
            prop="compServer"
          >
            <el-select
              v-model="formData.compServer"
              placeholder="请选择"
              multiple
              style="width: 100%"
              size="large"
            >
              <el-option
                v-for="item in compServerOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="isRead" label-width="0">
            <el-checkbox name="type" v-model="formData.isRead"></el-checkbox>
            <span style="margin-left: 8px" class="is-read">
              我已经阅读并同意
              <a class="hover" :href="agreementsUrl" target="_blank"
                >《服务协议》</a
              >和
              <a :href="termUrl" class="hover" target="_blank">《隐私条款》</a>
            </span>
          </el-form-item>
          <el-form-item class="btn">
            <el-popconfirm
              popper-class="btn-popper"
              title="确认是否取消?"
              @confirm="close"
              confirm-button-text="确认"
            >
              <el-button slot="reference">取消</el-button>
            </el-popconfirm>
            <el-button
              :loading="loading"
              type="primary"
              style="margin-left: 10px"
              @click="onSubmit('form')"
              >创建</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listServerType,
  listMainCategory,
  getCountryList,
  getProvinceList,
  getCityList,
  CreateUserCompany,
} from "@/utils/api/account";
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      agreementsUrl: "https://static.haizol.com/terms/agreements-cn.html",
      termUrl: "https://static.haizol.com/terms/term-cn.html",
      FORM_RULES: {
        compName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        stateId: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        provinceId: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        cityId: [
          { required: true, message: "请选择所在城市", trigger: "change" },
        ],
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        compAbilities: [
          { required: true, message: "请选择工艺", trigger: "change" },
        ],
        compServer: [
          { required: true, message: "请输入服务类型", trigger: "change" },
        ],
        isRead: [
          {
            required: true,
            message: "请阅读并同意服务协议和隐私条款",
            trigger: "change",
          },
        ],
      },
      formData: {
        userType: "", //用户类型
        compName: "", //公司名称
        stateId: "", //国家
        provinceId: "", //省份
        cityId: "", //城市ID
        contactName: "", //联系人
        compAbilities: [], //工艺
        isRead: false, //阅读协议
        compServer: [], //服务类型
      },
      form: null,
      identityList: [
        { label: "采购商", value: 2 },
        { label: "供应商", value: 1 },
        { label: "服务商", value: 3 },
      ],
      isValidateResult: false,
      compAbilitiesOptions: [], //工艺
      compServerOptions: [], //服务类型
      countryList: [], //国家
      regionList: [], //省份
      cityList: [], //城市
    };
  },
  mounted() {
    this.getCategoryInfo();
    this.getServerInfo();
    this.getCountryListFn();
  },
  components: {},
  computed: {
    cityIsNeedWrite() {
      return this.formData.stateId
        ? !["247"].includes(this.formData.stateId)
        : false;
    },
  },
  methods: {
    handleCompAbilities(data) {
      if (data.length == 5) {
        this.$message.warning("最多选择5个工艺!");
      }
    },
    onConfirm(val, context = {}) {
      this.loading = true;
      let params = {
        ...this.formData,
      };
      params.stateId = parseInt(params.stateId); //国家
      params.provinceId = parseInt(params.provinceId); //省份
      params.cityId = parseInt(params.cityId); //城市ID
      if (params.userType == 3) {
        params.compAbilities = params.compServer;
      } else if (params.userType == 2) {
        delete params.compAbilities;
      }
      delete params.compServer;

      CreateUserCompany(params)
        .then((res) => {
          const bizCode = res.rspResult.bizCode;
          const codeArr = [401, 403, 404, 1302, 14003];

          if (bizCode === 200) {
            console.log(res);
            this.$message.success("提交成功！");
            this.close();
          } else if (!codeArr.includes(bizCode)) {
            this.$message.error(res.rspResult.message);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
    close(val, context = {}) {
      this.$refs.form.resetFields();
      this.formData.userType = '';
      this.formData.isRead = false;
      this.$emit("close");
    },
    async getCategoryInfo() {
      try {
        const res = await listMainCategory();
        if (res.rspResult.bizCode === 200) {
          this.compAbilitiesOptions = res.rspListData.list.map((data) => {
            return {
              group: data.name,
              children: data.subCatageries.map((item) => {
                return {
                  label: item.name,
                  value: item.codeValue,
                };
              }),
            };
          });
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async getServerInfo() {
      try {
        const res = await listServerType();
        if (res.rspResult.bizCode === 200) {
          this.compServerOptions = res.rspListData.list.map((data) => {
            return {
              label: data.cn,
              value: data.id,
            };
          });
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    /**
     * 切换国家
     * @param {number} stateId 国家代码
     */
    changeCountry(stateId) {
      const _res = this.countryList.find((item) => item.codeValue === stateId);
      if (_res) {
        this.getProvinceListFn(stateId);
      } else {
        this.regionList = [];
      }
      this.formData.provinceId = "";
      this.formData.cityId = "";
    },
    /**
     * 切换省份
     * @param {number} provinceId 省份id
     */
    changeRegion(provinceId) {
      const _res = this.regionList.find(
        (item) => item.codeValue === provinceId
      );
      if (_res) {
        this.getCityListFn(provinceId);
      } else {
        this.cityList = [];
      }
      this.formData.cityId = "";
    },
    // 获取国家列表
    async getCountryListFn() {
      const res = await getCountryList();
      if (res.rspResult.bizCode === 200) {
        this.countryList = res.rspListData.list;
        this.countryList.forEach((row, index) => {
          if (row.codeValue === "247") {
            //中国
            this.countryList.splice(index, 1);
            this.countryList.unshift(row);
          }
        });
      }
    },
    // 获取省份
    async getProvinceListFn(stateId) {
      const res = await getProvinceList({ id: stateId });
      if (res.rspResult.bizCode === 200) {
        this.regionList = res.rspListData.list;
      }
    },
    // 获取城市
    async getCityListFn(provinceId) {
      const res = await getCityList({ id: provinceId });
      if (res.rspResult.bizCode === 200) {
        this.cityList = res.rspListData.list;
      }
    },

    handleIdentity(value) {
      if (this.formData.userType === value) return;
      this.formData.userType = value;
      if (value === 3) {
        if (this.formData.stateId != "247") {
          this.formData.stateId = "247";
          this.changeCountry(this.formData.stateId);
        }
        this.formData.compAbilities = [];
      } else {
        this.formData.compServer = [];
      }
      this.$refs.form.clearValidate();
    },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          if (this.formData.isRead) {
            // this.$confirm("是否提交创建?", "提示", {
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            //   type: "warning",
            // })
            //   .then(() => {
            this.onConfirm();
            // })
            // .catch(() => {});
          } else {
            this.$message.warning("请勾选协议");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.Company .el-dialog {
  font-family: SourceHanSansCN-Regular;
  padding: 32px;
  border-radius: 8px;
  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 0 0;
  }
}

::v-deep.CreateCompany {
  .el-form-item--small.el-form-item {
    margin-bottom: 24px;
  }
  .el-form-item__label {
    color: rgb(79, 93, 120);
    height: 40px;
    line-height: 40px;
  }
  .btn {
    margin-bottom: 0px !important;
    .el-form-item__content {
      display: flex;
      justify-content: flex-end;
    }
    .el-button {
      font-size: 14px;
    }
    .el-popover {
      padding: 16px;
    }
  }
}
.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
.title-text {
  color: rgb(152, 163, 183);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 8px;
}
.info {
  // padding: 32px;
}
.identity-list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .identity-item {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    border-radius: 2px;
    border: 1px solid #cfd5df;
    position: relative;
    font-size: 12px;
    font-weight: 400;
    color: #16181a;
    cursor: pointer;
    .i-item-icon {
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-right: 28px solid transparent;
      border-top: 28px solid rgba(6, 110, 183, 1);
      .el-icon-check {
        position: absolute;
        top: -27px;
        font-size: 14px;
        color: #fff;
        left: 2px;
      }
    }
  }
  .identity-item-avtive {
    border: 1px solid #066eb7;
    cursor: inherit;
    color: #066EB7;
  }
}
.is-read {
color: #16181A;
  white-space: nowrap;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  a {
    color: rgba(6, 110, 183, 1);
  }
}
::v-deep(.el-input__inner::placeholder){
  color: #98A3B7;
  font-family: SourceHanSansCN-Regular;
 font-size: 14px;
 font-style: normal;
 font-weight: 400;
 line-height: normal;
}
</style>
